export default "__VITE_PUBLIC_ASSET__bb890dde__"